import React, { useContext, useState } from 'react';
import classnames from 'classnames';

import ToastWrapper from '@common/helpers/toastWrapper';
import { useTranslation } from '@common/hooks/translation';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { getSwarmSetRfidPinCodeRequest } from '@app/dev/helpers/terminalRequests/rfid';

import { getOriginalCpf } from '@app/dev/helpers/formatCpfNumber';
import { RESPONSE_CODES_ENUM } from '@app/dev/constants/enums/responseCodes';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import { steps } from './stepsConfig';

import './style.scss';

const ForgotPassword = ({ cpf = '' }) => {
  const t = useTranslation();
  const [form, setForm] = useState({
    cpf,
    pin: '',
    confirmPin: '',
  });
  const [currentStep, setCurrentStep] = useState(0);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [{ openPopup }] = useContext(PopupContext);

  const onSubmit = async () => {
    setLoading(true);

    try {
      const params = {
        PinCode: form.pin,
        Rfid: getOriginalCpf(form.cpf),
      };

      const res = await swarmRequest(getSwarmSetRfidPinCodeRequest(params), 'betshop_command');

      switch (res.code) {
        case RESPONSE_CODES_ENUM.SUCCESS:

          return openPopup(POPUPS.RESET_SUCCESS);
        case RESPONSE_CODES_ENUM.CLIENT_NOT_FOUND:
          return ToastWrapper('error', 'Client Not Found');
        default:
          return ToastWrapper(res.data);
      }
    } catch (ex) {
      ToastWrapper('error', ex.data);
    } finally {
      setLoading(false);
    }
  };

  const stepData = steps[currentStep];

  const onContinue = () => {
    if (stepData.validate(form, setErrors)) {
      if (currentStep === steps.length - 1) onSubmit();
      else setCurrentStep(currentStep + 1);
    }
  };

  const onBack = () => {
    if (currentStep === 0) return openPopup(POPUPS.SIGN_IN, { cpf: form.cpf });

    return setCurrentStep(currentStep - 1);
  };

  const StepComponent = steps[currentStep].component;

  return (
    <div className="popup-content popup-small">

      <div className="popup-main-content">
        <StepComponent form={form} errors={errors} setForm={setForm} />
      </div>
      <div className="popup-actions">
        <button
          type="button"
          onClick={onBack}
          className="popup-cancel-button"
        >
          {
            currentStep === steps.length - 1
              ? t('Close')
              : (
                <>
                  {/* <i className="global-icon icon-arrow-line-left button-icon left" /> */}
                  {t('Back')}
                </>
              )
          }
        </button>
        <button
          type="button"
          onClick={onContinue}
          disabled={loading}
          className={classnames('popup-confirm-button', { disabled: loading })}
        >
          {t(stepData.nextButtonText || 'Next')}
          {/* {
            currentStep !== steps.length - 1
            && <i className="global-icon icon-arrow-line-right button-icon" />
          } */}
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
